import React, { useState, useEffect } from "react";
import "./main_dashboard.css";
import Top_navbar from "./Top_navbar";
// import Recent_order from "./Recent_order";
import { Select, Skeleton } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCreditCard, faAddressBook, faUser , faFolder} from '@fortawesome/free-regular-svg-icons';
import { getDashboardData } from '../../controllers/users/usersControllet';
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";


const Dashboard = () => {

  const [isLoading, setIsLoading] = useState(true);
  const [contactQueriesCount, setContactQueriesCount] = useState("");
  const [registrationQueriesCount, setRegistrationQueriesCount] = useState("");
  const [jobApplyQueriesCount, setJobApplyQueriesCount] = useState("");

  const getData = async () => {
    try {
      setIsLoading(true);
      const res = await getDashboardData();
      setContactQueriesCount(res?.contactQueriesCount || 0);
      setRegistrationQueriesCount(res?.registrationQueriesCount || 0);
      setJobApplyQueriesCount(res?.jobApplyQueriesCount || 0);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
  const [USERDATA, setUserData] = useState(user || "");

  useEffect(() => {
    getData();
  }, [])

  return (
    <>
      <Top_navbar></Top_navbar>
      <div className="container-fluid">
        <div className="row">
          {(user?.admin_type === 'Super Admin') && (
          <div className="col-md-4 px-0">
            <Link to="/contacts" style={{textDecoration:"none"}}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{ marginLeft: '10px', marginRight: '10px' }}><FontAwesomeIcon icon={faAddressBook} /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user">
                    { contactQueriesCount ? contactQueriesCount : 0 }{" "}
                    Contact Queries</h1>
                </div>
                <p className="presentation my-2">
                  Represents total number of contact queries received <br />
                </p>
              </div>
            </div>
            </Link>
          </div>
          )}
          {(user?.admin_type === 'Super Admin' || user?.admin_type === 'admission-admin') && (
          <div className="col-md-4 px-0">
            <Link to="/registrations" style={{textDecoration: "none"}}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{ marginLeft: '10px', marginRight: '10px' }}>  <FontAwesomeIcon icon={faUser} className="sidebar_collapse_iohomeoutline" /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user">
                    { registrationQueriesCount ? registrationQueriesCount : 0 }{" "}
                    Admission Queries</h1>
                </div>
                <p className="presentation my-2">
                  Represents total number of admission queries received <br />
                </p>
              </div>
            </div>
            </Link>
          </div>
          )}
          {(user?.admin_type === 'Super Admin' || user?.admin_type === 'hr-admin') && (
          <div className="col-md-4 px-0">
            <Link to="/job-applications" style={{textDecoration:"none"}}>
            <div className="transaction_form">
              <div className="transaction_Card margin-right">
                <span style={{ marginLeft: '10px', marginRight: '10px' }}><FontAwesomeIcon icon={faFolder} /></span>
                <div className="transction_main_Card ">
                  <h1 className="dashboard_top_heading_user">
                    { jobApplyQueriesCount ? jobApplyQueriesCount : 0 }{" "}
                    Job Application</h1>
                </div>
                <p className="presentation my-2">
                  Represents total number of job applications received <br />
                </p>
              </div>
            </div>
            </Link>
          </div>
          )}
        </div>

      </div>
    </>
  );
};

export default Dashboard;
